import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://suqhghcyhifbwfymqeim.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN1cWhnaGN5aGlmYndmeW1xZWltIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQzNTkxMjIsImV4cCI6MjA5OTkzNTEyMn0.MEoGXD9txwJNEBv0AAepVUR374jkEEDpm3MgGUDawgc'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})